module.exports = __webpack_public_path__ + "static/img/pause.fc0367bd.png";